module.exports = __webpack_public_path__ + "static/media/delivery.e8b936fc.svg";